import React from "react";
import { Grid } from "react-mdl/lib/Grid";
import WidgetGrid from "@techsoftware/happay-widgets/Grid";

export default class CustomGrid extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            noSpacing = false,
            style = {},
            isWidgetComp = false,
            direction,
            justify,
            alignItems,
            className,
            value,
            key,
            onClick,
            sm,
            xs,
            md,
            lg,
            xl,
            container,
            item
        } = this.props;
        if (isWidgetComp) {
            return (
                <WidgetGrid
                    {...this.props}
                    container={container}
                    item={item}
                    key={key}
                    value={value}
                    xs={xs}
                    sm={sm}
                    md={md}
                    lg={lg}
                    xl={xl}
                    direction={direction}
                    justify={justify}
                    alignItems={alignItems}
                    className={className}
                    style={style}
                    onClick={onClick}
                />
            );
        }
        return <Grid {...this.props} noSpacing={noSpacing} style={Object.assign({}, style)} />;
    }
}
